export interface UnifiedRow {
  entity_kind: 'posp' | 'channel';
  id: string;
  type_label: string;
  channel_id?: string | null;
}

export function resolveChannelDetailView(
  row: UnifiedRow,
): { mode: 'posp' | 'standard'; pospId: string | null } {
  if (row.type_label?.toUpperCase() === 'POSP') {
    return { mode: 'posp', pospId: row.entity_kind === 'posp' ? row.id : null };
  }
  return { mode: 'standard', pospId: null };
}
